<!-- eslint-disable vue/no-v-html -->
<template>
  <Modal
    hide-close-button
    offset-menu
  >
    <div class="modal-padding">
      <h2 class="modal-title">
        {{ title }}
      </h2>
      <div class="sub-titles">
        {{ $t("modals.confirm_notification_toggle_modal.change_title") }}
      </div>
      <div class="blue-background">
        <div class="user-access-title">
          <div>
            {{ $t("modals.confirm_notification_toggle_modal.user_title") }}
          </div>
          <div>
            {{ $t("modals.confirm_notification_toggle_modal.access_title") }}
          </div>
        </div>
        <div v-if="updates.length > ITEM_THRESHOLD_TO_USE_SCROLLER">
          <div class="scroller-container">
            <RecycleScroller
              v-slot="{ item }"
              :item-size="30"
              :items="updates"
              key-field="id"
              style="height: 100%"
            >
              <div class="scroller-container-max-width">
                <div class="scroller-container-absolute">
                  {{ item.name }}
                </div>

                <div class="scroller-container-margin-left">
                  {{
                    item.removed
                      ? $t(
                          "modals.confirm_notification_toggle_modal.removed_status"
                        )
                      : item.label
                  }}
                </div>
              </div>
            </RecycleScroller>
          </div>
        </div>
        <div v-else>
          <div class="non-scroller-container">
            <div
              v-for="(item, index) in updates"
              :key="index"
            >
              <div class="scroller-container-max-width-margin-top">
                <div style="position: absolute">
                  {{ item.name }}
                </div>

                <div class="scroller-container-margin-left">
                  {{
                    item.removed
                      ? $t(
                          "modals.confirm_notification_toggle_modal.removed_status"
                        )
                      : item.label
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sub-titles">
        {{ $t("modals.confirm_notification_toggle_modal.notify_title") }}
      </div>
      <p class="grey-message">
        {{
          $t("modals.confirm_notification_toggle_modal.notify_message", {
            type,
          })
        }}
      </p>
      <div class="flex">
        <div>
          <Checkbox
            v-model="emailNotification"
            :label="
              $t('modals.confirm_notification_toggle_modal.toggle_email_label')
            "
            label-class="smaller"
            new-design
          />
        </div>

        <div class="q-ml-xl">
          <Checkbox
            v-model="phoneNotification"
            :label="
              $t('modals.confirm_notification_toggle_modal.toggle_mobile_label')
            "
            label-class="smaller"
            new-design
          />
        </div>
      </div>
      <div class="share-buttons">
        <BaseButton
          class="share-buttons-cancel"
          color="secondary"
          :label="$t('global.cancel')"
          new-design
          @click="cancel"
        />
        <BaseButton
          color="primary"
          :label="$t('global.confirm')"
          new-design
          @click="confirm"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import { getLocaleText } from "shared/boot/i18n";
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";

const ITEM_THRESHOLD_TO_USE_SCROLLER = 6;

export default {
  name: "ConfirmNotificationToggleModal",
  components: {
    BaseButton,
    Modal,
  },
  props: {
    updates: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () =>
        getLocaleText("modals.confirm_notification_toggle_modal.default_type"),
    },
    title: {
      type: String,
      default: "",
    },
    defaultState: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true,
    },
  },
  emits: ["close", "cancel", "confirm"],
  data() {
    return {
      emailNotification: this.defaultState,
      phoneNotification: this.defaultState,
    };
  },
  computed: {
    ITEM_THRESHOLD_TO_USE_SCROLLER() {
      return ITEM_THRESHOLD_TO_USE_SCROLLER;
    },
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm", {
        emailNotification: this.emailNotification,
        phoneNotification: this.phoneNotification,
      });

      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.streem-modal2) {
  width: auto !important;
  margin: 0 auto !important;
}

.modal-title {
  font-size: rem;
  font-weight: bold;
  line-height: normal;
  color: $ds-denim-9;
}

.share-buttons {
  display: flex;
  margin-top: 10px;
  gap: var(--s-spacing-md);

  &-cancel {
    margin-left: 200px;
  }
}

@media only screen and (width <= 500px) {
  .share-buttons {
    &-cancel {
      margin-left: 150px;
    }
  }
}

:deep(.checkbox-label) {
  font-size: 0.75rem;
}

.modal-padding {
  padding-left: 5px;
  padding-right: 5px;
}

.sub-titles {
  font-size: 0.75rem;
  font-weight: 700;
  margin-top: 25px;
}

.blue-background {
  background-color: #f5f7f9;
  padding: 12px 0 20px 20px;
  border-radius: 3px;
  margin-top: 16px;
}

.grey-message {
  color: #707889;
  font-size: 0.625rem;
  margin: 5px 0 2px;
}

.updated-users-label-size {
  font-size: 0.75rem;
  margin: 8px 0 0;
}

.updated-users-label-weight {
  font-weight: 700;
}

.scroller-container {
  margin-top: 0.8rem;
  font-size: 0.9rem;
  height: 150px;

  &-max-width {
    max-width: 300px;

    &-margin-top {
      margin-top: 10px;
    }
  }

  &-absolute {
    position: absolute;
  }

  &-margin-left {
    margin-left: 203px;
  }
}

.scroller-container::after {
  content: "";
  position: absolute;
  bottom: 9.8rem;
  height: 70px;
  left: 35px;
  right: 35px;
  background: linear-gradient(to bottom, transparent, #f5f7f9);
  pointer-events: none;
}

.non-scroller-container {
  margin-top: 0.8rem;
  font-size: 0.9rem;
}

.user-access-title {
  display: flex;
  justify-content: space-between;
  max-width: 250px;
  font-size: 0.9rem;
  font-weight: 700;
}
</style>
